import { Injectable } from '@angular/core'
import {
  HttpService,
  IExportFileResponse,
  INew_TableAction,
  TableActionsService,
  TableFilterService
} from '@lla-platform/core/core-data-access'
import { DateService } from '@lla-platform/core/core-util'
import { Observable } from 'rxjs'
import { IFluidsRequest, IFluidsResponse } from '../interfaces/fluids.interface'
import { FLUIDS_API_URL } from './fluids-api-routes'
import { IFluidsListResponse } from '../interfaces/fluids-list.interface'

@Injectable({
  providedIn: 'root'
})
export class FluidsService {
  constructor(
    private http: HttpService,
    private dateService: DateService,
    private tableFilterService: TableFilterService,
    private tableActionsService: TableActionsService
  ) {}

  getFluidsSummary(payload: IFluidsRequest): Observable<IFluidsResponse> {
    const { from, to } = payload
    return this.http.post(FLUIDS_API_URL.fluidsSummary, {
      ...payload,
      from: this.dateService.momentToDateString(from),
      to: this.dateService.momentToDateString(to)
    })
  }

  exportFluidsSummary(payload: IFluidsRequest): Observable<IExportFileResponse> {
    const { from, to } = payload
    return this.http.post(FLUIDS_API_URL.exportFluidsSummary, {
      ...payload,
      from: this.dateService.momentToDateString(from),
      to: this.dateService.momentToDateString(to)
    })
  }

  getFluidsList(info: INew_TableAction): Observable<IFluidsListResponse> {
    return this.http.post(FLUIDS_API_URL.fluidsList, this.tableActionsService.createRequestPayload(info))
  }

  exportFluidsList(info: INew_TableAction): Observable<IExportFileResponse> {
    return this.http.post(
      FLUIDS_API_URL.exportFluidsList,
      this.tableActionsService.createRequestPayload(info)
    )
  }
}
